import * as React from 'react';

import { useLocalStore } from 'hooks/';

import { BasicFormStore } from './BasicFormStore';

const BasicFormStoreContext = React.createContext<BasicFormStore | null>(null);

export const BasicFormStoreProvider = ({
  children,
}: React.PropsWithChildren) => {
  const store = useLocalStore(() => new BasicFormStore());

  return (
    <BasicFormStoreContext.Provider value={store}>
      {children}
    </BasicFormStoreContext.Provider>
  );
};

export const useBasicFormStore = () => {
  const context = React.useContext(BasicFormStoreContext);

  if (!context) {
    throw new Error('BasicFormStoreContext is not found');
  }

  return context;
};
